'use client';
import { FC, ReactNode, useMemo, useState } from 'react';
import ProductTabItem from '@/features/contentful/components/FeaturedProductList/ProductTabItem';
import ContentLayout from '@/layouts/ContentLayout';
import FeaturedProductSelect from '@/features/contentful/components/FeaturedProductList/FeaturedProductSelect';
import classNames from 'classnames';

interface Props {
    subtitle?: string;
    className?: string;
    options: { label: string; id: string }[];
    children: ReactNode[];
}

const FeaturedProductList: FC<Props> = ({ options, subtitle, className, children }) => {
    const [activeLabel, setActiveLabel] = useState(options[0].label);

    const onTabClickHandler = (label: string) => {
        setActiveLabel(label);
    };

    const activeIndex = useMemo(
        () => options.findIndex((option) => option.label === activeLabel),
        [activeLabel, options],
    );
    return (
        <section className={classNames('tw-w-full tw-bg-bgSkyLight', className)}>
            <ContentLayout>
                {subtitle ? (
                    <h2 className="tw-text-pink1 tw-text-[14px] tw-uppercase tw-px-[10px] tw-font-gotham-medium tw-pb-0">
                        {subtitle}
                    </h2>
                ) : null}

                <FeaturedProductSelect onOptionClick={onTabClickHandler} options={options} />
                <div className="tw-w-full tw-flex tw-mt-[24px]">
                    <div className="tw-hidden md:tw-block  tw-w-full ">
                        {options.map((option) => (
                            <ProductTabItem
                                key={option.label}
                                id={option.id}
                                active={option.label === activeLabel}
                                onClick={onTabClickHandler}
                                label={option.label}
                            />
                        ))}
                    </div>
                    <div className="sm:tw-px-[10px] tw-w-full">{children[activeIndex]}</div>
                </div>
            </ContentLayout>
        </section>
    );
};

export default FeaturedProductList;
